export default {
  getCategories(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("forum/categories/")
        .then(function(response) {
          context.commit("setCategories", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  setCategories(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .put("forum/data-forum/", data)
        .then(function(response) {
          resolve(response);
        })
        .catch(reject);
    });
  },

  createTopic(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("forum/", data)
        .then(function(response) {
          resolve(response);
        })
        .catch(reject);
    });
  },

  editTopic(context, { id, data }) {
    return new Promise((resolve, reject) => {
      window.axios
        .put("forum/post-alter/" + id, data)
        .then(function(response) {
          resolve(response);
        })
        .catch(reject);
    });
  },

  getTopics(context, limit) {
    if (!limit) {
      limit = 3;
    }
    return new Promise((resolve, reject) => {
      window.axios
        .get(`forum/post/?page_size=${limit}`)
        .then(function(response) {
          context.commit("setTopics", response.data.results);
          context.commit("setCount", response.data.count);
          resolve();
        })
        .catch(reject);
    });
  },

  getTopicById(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`forum/post-view/${id}`)
        .then(function(response) {
          context.commit("setTopic", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  likedTopic(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`forum/post-like/?post_id=${id}`)
        .then(function(response) {
          resolve(response);
        })
        .catch(reject);
    });
  },

  getCategoriesSelected(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("forum/data-forum/")
        .then(function(response) {
          resolve(response.data);
        })
        .catch(reject);
    });
  },

  deleteTopic(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`forum/post-alter/${id}`)
        .then(function(response) {
          resolve(response);
        })
        .catch(reject);
    });
  },

  filterByCategories(context, { id, limit }) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`forum/filter-category/?categories=${id}&page_size=${limit}`)
        .then(function(response) {
          context.commit("setTopics", response.data.results);
          context.commit("setCount", response.data.count);
          resolve();
        })
        .catch(reject);
    });
  },

  report(context, { id, data }) {
    return new Promise((resolve, reject) => {
      window.axios
        .post(`forum/post-complaint/${id}`, data)
        .then(resolve)
        .catch(reject);
    });
  },

  getBestUsers(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("forum/data-forum/")
        .then(function(response) {
          context.commit("setBestUsers", response.data.best_scores_users);
          resolve();
        })
        .catch(reject);
    });
  },

  getTags(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("forum/data-forum/")
        .then(function(response) {
          context.commit("setTags", response.data.popular_tags);
          resolve();
        })
        .catch(reject);
    });
  },

  filterByTags(context, tag) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`forum/filter-tags/?tag=${tag}`)
        .then(function(response) {
          context.commit("setTopics", response.data.results);
          context.commit("setCount", response.data.count);
          resolve();
        })
        .catch(reject);
    });
  },

  createComment(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post(`comments/forum/`, data)
        .then(resolve)
        .catch(reject);
    });
  },

  getComments(context, { id, limit }) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`comments/forum/${id}?limit=${limit}`)
        .then(function(response) {
          context.commit("setComments", response.data.results);
          context.commit("setCount", response.data.count);
          resolve();
        })
        .catch(reject);
    });
  },

  filterTopicsByText(context, { text }) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`forum/post/?search=${text}`)
        .then(function(response) {
          context.commit("setTopics", response.data.results);
          context.commit("setCount", response.data.count);
          resolve();
        })
        .catch(reject);
    });
  }
};
